import { hasWindow } from "@litres/utils";
import { trackerSendHeaderClick } from "../../utils/analytics";

export const trackerClick = (
  title: string,
  _id: string,
  _isUserAnonymous: boolean
) => {
  trackerSendHeaderClick(title, hasWindow ? window.location.href : "");
};
